<template>
    <div>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-12">
                <Message severity="warn" :sticky="true" :closable="false">
                    Atenção! <br/>
                    Selecione com cuidado o motivo e os funcionários.<br/>
                    Selecione um período (início e final) para afastamento não definitivo. Selecione uma data final para afastamento definitivo.<br/>
                    Para transferência: após aplicar o afastamento, selecione a guia Transferência pra transferir o(s) funcionário(s).
                </Message>
            </div>                      
        </div> 
        <div class="p-col-12 p-md-12" v-if="progresso > 0"> 
            Aguarde! Atualizando ponto...<i class="pi pi-spin pi-spinner" ></i>
            <ProgressBar :value="progresso" class="p-mb-2" v-if="progresso > 0"/>
        </div>
        <IKFiltroFuncionarioContrato ref="ikFiltroFuncionarios"/>
		<div class="p-fluid p-formgrid p-grid p-mt-5">
            <div class="p-field p-col-12 p-md-12">
                <label>Motivo</label>
                <Dropdown v-model.number="idMotivoSelecionado" :options="motivos" optionLabel="novaDescricao" 
                    optionValue="id" dataKey="id" :filter="true" placeholder="Selecione"/>
            </div>                      
        </div>               
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label>Data início</label>
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Data final</label>
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
            </div>
        </div>
        <Button label="Salvar" icon="pi pi-check" class="p-mt-3" @click="salvar" v-if="permissaoNovo"/>

        <Dialog :visible.sync="exibirDialogAviso" header="Importante" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Atenção!</span>
                <h6>Selecione a guia Transferência para conluir.</h6>
            </div>
            <template #footer>
                <Button label="OK" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>               
            </template>
        </Dialog>

    </div>
</template>

<script>
import IKFiltroFuncionarioContrato from '@/components/template/IKFiltroFuncionarioContrato.vue';
import MotivoAfastamentoService from '@/service/MotivoAfastamentoService';
import AfastamentoService from '@/service/AfastamentoService';
import ControlePontoService from '@/service/ControlePontoService.js';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    controlePontoService: null,
    afastamentoService: null,
    motivoAfastamentoService: null,
	data() {
		return {
            exibirDialogAviso: false,
            permissaoNovo: false,			
            dataInicio: new Date(),
			dataFinal: new Date(),
			idMotivoSelecionado: null,
			motivos: [],
            localeCalendarBR: localeCalendarBR,
            progresso: 0,
            pararTimeout: false,
		}
	},
	methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
        ...mapActions('funcionario', ['inluirDadosTransferencia']),
        /**
         * 
         */
        salvar() {          
            let filtro = this.$refs.ikFiltroFuncionarios.getFiltro();
            let funcionarios = filtro.funcionarios;
            if(funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            if(this.idMotivoSelecionado == null) {
                exibirMensagemSis(this, 'Selecione um motivo', true);
                return;
            }           
            let motivo = null;
            for(let i = 0; i < this.motivos.length; i++) {
                if(this.idMotivoSelecionado == this.motivos[i].id) {
                    motivo = {...this.motivos[i]};
                }
            }		
            if(motivo.descricao == 'Transferência') {
                let dados = {
                    cnpj: filtro.cnpj,
                    funcionarios: funcionarios,
                    dataFinal: this.dataFinal,
                    motivo: motivo,                    
                }
                this.inluirDadosTransferencia(dados);
                this.$refs.ikFiltroFuncionarios.limparSelecionados();
                this.idMotivoSelecionado = null;
                this.exibirDialogAviso = true;
                return;
            } else {
                let requisicao = {
                    cnpj: filtro.cnpj,
                    idsFuncionarios: idsFuncionarios,
                    motivo: motivo,       
                    dataInicio: this.formatarData(this.dataInicio),
                    dataFinal: this.formatarData(this.dataFinal),
                    usuarioRequisicao: {...this.getDadosRequisicao()}
                };	
                this.afastamentoService.salvar(requisicao)
                .then(resp => {                    
                    if(resp.data instanceof Array) {
                        exibirMensagemSis(this, 'Sucesso', false);     
                    } else {
                        exibirMensagem(this, resp);   
                    } 
                    if(resp.data instanceof Array && resp.data.length > 0) {
                        this.atualizarPonto(resp.data);
                    }                  
                })
                .catch(erro => {exibirMensagem(this, erro)});
            }               
        },
        /**
         * 
         */
         atualizarPonto(rangeDatas) {
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro(); 
            this.$refs.ikFiltroFuncionarios.limparSelecionados();           
            let requisicoes = [];                   
            const fabricaRequisicoes = {
                criar: (range, dados) => {
                    return {
                        mes: range.mes,
                        ano: range.ano,
                        dataInicio: range.dataInicio,
                        dataFinal: range.dataFinal,
                        cnpj: dados.cnpj,
                        funcionarios: [],      
                        usuarioRequisicao: this.getDadosRequisicao(),          
                    };
                }
            }
            rangeDatas.forEach(range => {
                let requisicao = fabricaRequisicoes.criar(range, dados);
                requisicoes.push(requisicao);
                let qtd = 0;
                dados.funcionarios.forEach(funcio => {                
                    if(qtd < 5) {                        
                        qtd++;
                    } else {
                        qtd = 1;
                        requisicao = fabricaRequisicoes.criar(range, dados);
                        requisicoes.push(requisicao);
                    }
                    requisicao.funcionarios.push(funcio);
                }); 
            });                 
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.progresso = 1;             
            this.calcularPeriodoEditadoRecursivo(1, requisicoes);
        },
        /**
         * 
         */
        calcularPeriodoEditadoRecursivo(pagina, requisicoes) {    
            if(this.pararTimeout) {
                return;
            }       
            let requisicao = requisicoes[(pagina-1)];          
            this.controlePontoService.calcularPeriodoEditado2(requisicao, 'fdb=f')
            .then(()=>{
                if((pagina + 1) > requisicoes.length) {                       
                    this.progresso = 100;
                    setTimeout(() => { this.progresso = 0; }, 1000);
                } else  {
                    this.progresso = Math.trunc((pagina / requisicoes.length)*100);
                    pagina++;
                    setTimeout(() => {
                        this.calcularPeriodoEditadoRecursivo(pagina, requisicoes);
                    }, 500);
                } 
            })
            .catch(erro => {                   
                exibirMensagem(this, erro);
                setTimeout(() => { this.progresso = 0; }, 3000);
            });
        },
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        /**
         * 
         */
        fecharModal() {
            this.exibirDialogAviso = false;
        },
        /**
         * 
         */
		listarMotivos() {	
			this.motivoAfastamentoService.listar({...this.getDadosRequisicao()})
            .then(resp => {
                resp.data.forEach(motivo => {
                    motivo['novaDescricao'] = motivo.descricao + ' ( '+(motivo.definitivo ? 'Definitivo' : 'Não Definitivo')+' )'
                    this.motivos.push(motivo);
                });   
            })
            .catch(erro => {exibirMensagem(this, erro)});   
		},
        /**
         * 
         */
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(103);		
		}
	},
	created() {
        this.controlePontoService = new ControlePontoService();
        this.afastamentoService = new AfastamentoService();
		this.motivoAfastamentoService = new MotivoAfastamentoService();
	},
	mounted() {
        this.listarMotivos();
        this.validarPermissoes();
	},
    beforeDestroy() {
        this.pararTimeout = true;
    },
	components: {
        'IKFiltroFuncionarioContrato': IKFiltroFuncionarioContrato,
    }
}
</script>

<style>

</style>